import { render, staticRenderFns } from "./DossiersEnCours.vue?vue&type=template&id=0627e640&scoped=true&"
import script from "./DossiersEnCours.vue?vue&type=script&lang=js&"
export * from "./DossiersEnCours.vue?vue&type=script&lang=js&"
import style0 from "./DossiersEnCours.vue?vue&type=style&index=0&id=0627e640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627e640",
  null
  
)

export default component.exports